import { render, staticRenderFns } from "./StatusDip.vue?vue&type=template&id=116a7a11&scoped=true&"
import script from "./StatusDip.vue?vue&type=script&lang=js&"
export * from "./StatusDip.vue?vue&type=script&lang=js&"
import style0 from "./StatusDip.vue?vue&type=style&index=0&id=116a7a11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116a7a11",
  null
  
)

export default component.exports